import type { CashbackInfo, CashbackSettingsAdapted } from '@/types/cashback';

export const cashbackSettingsAdapter = (data: CashbackInfo, currency: string): CashbackSettingsAdapted => {
    const { cashback } = data;
    // Если есть валюта игрока, возвращаем только её уровни
    if (currency && cashback.levels_by_currency[currency]) {
        return {
            is_enabled: cashback.is_enabled,
            levels: cashback.levels_by_currency[currency],
            schedule: cashback.schedule,
            currency: currency
        };
    }

    // Если нет валюты игрока или валюта не найдена, возвращаем все валюты
    return {
        is_enabled: cashback.is_enabled,
        levels: [], // Пустой массив, так как нет конкретной валюты
        schedule: cashback.schedule,
        all_currencies: cashback.levels_by_currency,
        currency: currency
    };
};
